import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';
import ForgotPassword from '../../pages/forgot-password';
import ForgotUsername from '../../pages/forgot-username';
import ResetPassword from '../../pages/reset-password/reset-password.page';
import SignIn from '../../pages/sign-in';
import {
  FORGOT_PASSWORD_PATH, FORGOT_USERNAME_PATH, RESET_PASSWORD_PATH, SIGN_IN_PATH,
} from '../paths.constants';

const GuestRouting: React.FC = (): JSX.Element => {
  const [redirectLocation, setRedirectLocation] = useState<Location | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (!location?.pathname.startsWith(SIGN_IN_PATH)) {
      setRedirectLocation(location);
    }
  }, [location]);

  return (
    <div className="auth">
      <Switch>
        <Route path={SIGN_IN_PATH} exact>
          <SignIn redirectLocation={redirectLocation} setRedirectLocation={setRedirectLocation} />
        </Route>
        <Route path={FORGOT_PASSWORD_PATH} component={ForgotPassword} exact />
        <Route path={FORGOT_USERNAME_PATH} component={ForgotUsername} exact />
        <Route path={RESET_PASSWORD_PATH} component={ResetPassword} exact />
        <Redirect to={SIGN_IN_PATH} />
      </Switch>
    </div>
  );
};

GuestRouting.displayName = 'GuestRouting';

export default GuestRouting;
